'use client';

import { useTranslations } from 'next-intl';
import type { CvssScoreStatus } from '@terra/shared-cvss';
import type { FindingSeverityType } from '@terra/shared-schemas-orchestrator';
import { BadgeSeverity } from '../../components/badge';
import { BodyDefault } from '../../components/typography';
import { useFindingCvssPendingLock } from './useFindingCvssPendingLock';

type FindingSeverityBadgeProps = {
  finding: {
    severity: FindingSeverityType;
    cvssScoreStatus?: CvssScoreStatus | null;
    cvssScoreRequestedAt?: Date | string | null;
    createdAt: Date | string;
  };
  size?: 'sm' | 'md';
};

export function FindingSeverityBadge({
  finding,
  size = 'sm',
}: FindingSeverityBadgeProps) {
  const t = useTranslations('designSystem.findings.cvssVersions');
  const calculating = useFindingCvssPendingLock({ finding });

  if (calculating) {
    return <BodyDefault>{t('calculating')}</BodyDefault>;
  }

  return (
    <BadgeSeverity severity={finding.severity} size={size}>
      {finding.severity}
    </BadgeSeverity>
  );
}
